import React, { useEffect, useState } from "react";
import "./vitalsModal.scss";
import { Drawer } from "@mui/material";
import close_icon from "../../../assets/crossIcon.svg";
import {
  APPLICABLE_ROLE,
  VITALS_LIST,
} from "../../DashboardAppointmentsView/Constant";
import VitalComponent from "../VitalComponent";
import {
  ADD_EDIT_VITALS,
  GET_VITALS,
} from "./VitalsModalApiHandler/apiConstants";
import swal from "sweetalert";
import Loader from "../../UI Component/Loader/Loader";
import VitalDatePickerInput from "../VitalDatePickerInput";
import moment from "moment";
import { c2cPostApiHandler } from "../../../Util/c2cApiHandler";

const VitalsModal = (props) => {
  const {
    openModal,
    title,
    appointment_id,
    patient_gender,
    user_type,
    user_id,
    staff_id,
    handleCloseModal,
  } = props;

  const [vitalsList, setVitalsList] = useState(
    JSON.parse(JSON.stringify(VITALS_LIST))
  );
  const [viewVitals, setViewVitals] = useState([]);
  const [loader, setLoader] = useState(false);

  // Lifecycle Methods ===>

  useEffect(() => {
    vitalsList.forEach((vi) => {
      vi.unit = vi.unit ? vi.unit : vi.unitList[0];
    });
    setVitalsList([...vitalsList]);
    if (title.toLowerCase() !== "add") {
      setLoader(true);
      getVitalsApi();
    }
  }, []);

  // <===

  // Api Calls ===>

  const getVitalsApi = () => {
    let reqPayload = { appointment_id: appointment_id };
    let data = c2cPostApiHandler(GET_VITALS, reqPayload);
    data.then(([res, err]) => {
      setLoader(false);
      if (!err) {
        if (res?.data?.statusCode === 200) {
          let resData = res?.data?.data[0];
          if (title.toLowerCase() === "view") {
            handleViewVitals(resData);
          } else {
            handleEditVitals(resData);
          }
        }
      }
    });
  };

  const addEditVitalsApi = (reqPayload) => {
    setLoader(true);
    let data = c2cPostApiHandler(ADD_EDIT_VITALS, reqPayload);
    data.then(([res, err]) => {
      setLoader(false);
      if (!err) {
        if (res?.data?.statusCode === 200) {
          swal({
            icon: "success",
            title: res.data.message,
            timer: 2000,
          });
          setTimeout(() => {
            handleCloseModal();
          }, 1500);
        }
      }
    });
  };

  // <===

  // Helper Methods ===>

  const getVitalComponentClassName = (item) => {
    if (window.innerWidth > 767) {
      return item.id % 2 === 0 ? "pl-1 pr-0" : "pl-0 pr-1";
    } else {
      return "pl-0 pr-0";
    }
  };

  const getRandomGlucoseClassName = (item) => {
    return item.name.toLowerCase() === "random glucose"
      ? " random-glucose-vital-component-unit"
      : "";
  };

  const getViewVitals = (res, key, name, unit) => {
    if (res[key]) {
      return { name: name, value: res[key], unit: unit };
    }
  };

  const handleViewVitals = (data) => {
    let arr = [];

    let weight = getViewVitals(data, "weight", "Weight", data.weight_unit);
    if (weight) {
      arr.push(weight);
    }
    let height = getViewVitals(data, "height", "Height", data.height_unit);
    if (height) {
      arr.push(height);
    }
    if (data.bp_systolic && data.bp_diastolic) {
      arr.push({
        name: "BP",
        value: data.bp_systolic + "/" + data.bp_diastolic,
        unit: "mmHg",
      });
    }
    let temp = getViewVitals(
      data,
      "temperature",
      "Temperature",
      data.temperature_unit
    );
    if (temp) {
      arr.push(temp);
    }
    let spo2 = getViewVitals(data, "spo2", "SPO2", "%");
    if (spo2) {
      arr.push(spo2);
    }
    let glucose = getViewVitals(
      data,
      "random_glucose",
      "Random Glucose",
      data.random_glucose_unit
    );
    if (glucose) {
      arr.push(glucose);
    }
    let pulse = getViewVitals(data, "pulse_rate", "Pulse Rate", "BPM");
    if (pulse) {
      arr.push(pulse);
    }
    let respiration = getViewVitals(
      data,
      "respiration_rate",
      "Respiration Rate",
      "BPM"
    );
    if (respiration) {
      arr.push(respiration);
    }
    let lmp = getViewVitals(data, "lmp", "LMP", "Days");
    if (lmp) {
      arr.push(lmp);
    }
    setViewVitals([...arr]);
  };

  const handleEditVitals = (data) => {
    vitalsList.forEach((vi) => {
      vi.value = data[vi.name.toLowerCase().replace(" ", "_")];
      vi.unit = data[vi.name.toLowerCase().replace(" ", "_") + "_unit"]
        ? data[vi.name.toLowerCase().replace(" ", "_") + "_unit"]
        : vi.unit;
    });
    setVitalsList([...vitalsList]);
  };

  // <===

  // Actions ===>

  const handleOnChange = (e, item) => {
    let index = vitalsList.findIndex((vi) => vi.id === item.id);
    vitalsList[index].value = e.target.value;
    setVitalsList([...vitalsList]);
  };

  const handleUpArrowClick = (item) => {
    let index = vitalsList.findIndex((vi) => vi.id === item.id);
    let ind = vitalsList[index].unitList.findIndex(
      (un) => un === vitalsList[index].unit
    );
    if (vitalsList[index].unitList[ind + 1]) {
      vitalsList[index].unit = vitalsList[index].unitList[ind + 1];
    } else {
      vitalsList[index].unit = vitalsList[index].unitList[0];
    }
    setVitalsList([...vitalsList]);
  };

  const handleDownArrowClick = (item) => {
    let index = vitalsList.findIndex((vi) => vi.id === item.id);
    let ind = vitalsList[index].unitList.findIndex(
      (un) => un === vitalsList[index].unit
    );
    if (vitalsList[index].unitList[ind - 1]) {
      vitalsList[index].unit = vitalsList[index].unitList[ind - 1];
    } else {
      vitalsList[index].unit =
        vitalsList[index].unitList[vitalsList[index].unitList.length - 1];
    }
    setVitalsList([...vitalsList]);
  };

  const handleSaveModal = () => {
    let vitalsPayload = {};
    let isEmpty = vitalsList.every((vi) => vi.value === "");
    if (title.toLowerCase() !== "add") {
      isEmpty = false;
    }
    if (!isEmpty) {
      vitalsList.forEach((vi) => {
        vitalsPayload[vi.name.toLowerCase().replace(" ", "_")] = vi.value;
        vitalsPayload[vi.name.toLowerCase().replace(" ", "_") + "_unit"] =
          vi.unit;
      });
      let reqPayload = {
        appointment_id: appointment_id,
        user_type: user_type,
        user_id: user_type === APPLICABLE_ROLE.DOCTOR ? user_id : staff_id,
        ...vitalsPayload,
      };
      addEditVitalsApi(reqPayload);
    } else {
      handleCloseModal();
    }
  };

  const handleDateChange = (date, item) => {
    let index = vitalsList.findIndex((vi) => vi.id === item.id);
    let dateOne = moment().format("YYYY-MM-DD");
    let dateTwo = moment(date).format("YYYY-MM-DD");
    vitalsList[index].value = date
      ? Math.abs(moment(dateOne).diff(dateTwo, "days")) + ""
      : "";
    setVitalsList([...vitalsList]);
  };

  // <===

  // Display UI ===>

  const displayVitalsModal = () => {
    return (
      <Drawer
        open={openModal}
        anchor="right"
        PaperProps={{
          sx: {
            width: window.innerWidth < 767 ? "100%" : "auto",
          },
        }}
      >
        {loader && <Loader />}
        <div className="vitals-modal-cont">
          {displayHeader()}
          {title.toLowerCase() !== "view"
            ? displayModalContent()
            : displayViewVitals()}
          {title.toLowerCase() !== "view" && displayFooter()}
        </div>
      </Drawer>
    );
  };

  const displayHeader = () => {
    return (
      <div className="vitals-modal-header">
        <div className="vitals-modal-header-title">{title} Vitals</div>
        <div className="vitals-modal-header-close" onClick={handleCloseModal}>
          {window.innerWidth > 767 && "Close"}{" "}
          <img
            src={close_icon}
            alt=""
            style={{
              width: window.innerWidth > 767 ? "" : "26px",
              height: window.innerWidth > 767 ? "" : "26px",
            }}
          />
        </div>
      </div>
    );
  };

  const displayModalContent = () => {
    return (
      <div className="vitals-modal-content">
        {vitalsList.map((item) =>
          item.name.toLowerCase() === "lmp" ? (
            patient_gender.toLowerCase() === "female" && (
              <div
                key={item.id}
                className={
                  "col-sm-12 col-md-6 col-lg-6 " +
                  getVitalComponentClassName(item)
                }
                style={{ marginBottom: "10px" }}
              >
                {item.name.toLowerCase() === "lmp" ? (
                  <div className="vitals-modal-lmp">
                    <VitalDatePickerInput
                      placeholder={item?.name}
                      differentInputFormat={
                        item.value ? item.value + " Days" : ""
                      }
                      selected_date={""}
                      maxDate={new Date()}
                      allowBackspace={true}
                      handleDateChange={(date) => handleDateChange(date, item)}
                    />
                  </div>
                ) : (
                  <VitalComponent
                    item={item}
                    placeholder={item.name}
                    value={item.value}
                    selectedUnit={item.unit}
                    unitList={item.unitList}
                    allowDecimal={true}
                    handleOnChange={handleOnChange}
                    handleUpArrowClick={handleUpArrowClick}
                    handleDownArrowClick={handleDownArrowClick}
                  />
                )}
              </div>
            )
          ) : (
            <div
              key={item.id}
              className={
                "col-sm-12 col-md-6 col-lg-6 " +
                getVitalComponentClassName(item) +
                getRandomGlucoseClassName(item)
              }
              style={{ marginBottom: "10px" }}
            >
              <VitalComponent
                item={item}
                placeholder={item.name}
                value={item.value}
                selectedUnit={item.unit}
                unitList={item.unitList}
                allowDecimal={true}
                handleOnChange={handleOnChange}
                handleUpArrowClick={handleUpArrowClick}
                handleDownArrowClick={handleDownArrowClick}
              />
            </div>
          )
        )}
      </div>
    );
  };

  const displayViewVitals = () => {
    return (
      <div className="vitals-modal-view">
        {!loader &&
          (viewVitals.length !== 0 ? (
            viewVitals.map((vi, ind) =>
              vi.name.toLowerCase() === "lmp" ? (
                patient_gender.toLowerCase() === "female" && (
                  <div key={ind} className="col-6 pl-0 pr-0">
                    <div className="vitals-modal-view-header">{vi.name}</div>
                    <div className="vitals-modal-view-value">
                      {vi.value} {vi.unit}
                    </div>
                  </div>
                )
              ) : (
                <div key={ind} className="col-6 pl-0 pr-0">
                  <div className="vitals-modal-view-header">{vi.name}</div>
                  <div className="vitals-modal-view-value">
                    {vi.value} {vi.unit}
                  </div>
                </div>
              )
            )
          ) : (
            <div className="no-vitals-added">No Vitals Added</div>
          ))}
      </div>
    );
  };

  const displayFooter = () => {
    return (
      <div
        className="vitals-modal-footer"
        style={{
          position: window.innerWidth > 767 ? "absolute" : "",
          justifyContent: window.innerWidth > 767 ? "end" : "",
          boxShadow: window.innerWidth > 767 ? "" : "none",
          paddingBottom: window.innerWidth > 767 ? "" : "30px",
        }}
      >
        <div className="vitals-modal-footer-save-btn" onClick={handleSaveModal}>
          Save
        </div>
      </div>
    );
  };

  // <===

  return <>{displayVitalsModal()}</>;
};

export default VitalsModal;
